import React from 'react';

var RightSideIcon = function (_a) {
    var setActiveOverlay = _a.setActiveOverlay;
    return (React.createElement("div", { className: 'pgc-right-side-button', onClick: function () { return setActiveOverlay(true); } },
        React.createElement("i", { className: 'icon-menu' })));
};

export { RightSideIcon };
